import { Endpoints, makeAuthGetRequest } from "../../network/http-client";
export class AuditLogService {
    auditLogStore;
    logStore;
    constructor(auditLogStore, logStore) {
        this.auditLogStore = auditLogStore;
        this.logStore = logStore;
    }
    async getAuditLog(userId, dateStart, dateEnd, logOnSuccess = false) {
        try {
            const timestampFrom = this.dateToTimestamp(dateStart);
            const timestampTo = this.dateToTimestamp(dateEnd);
            const auditLog = await this.fetchAuditLog(userId, timestampFrom, timestampTo);
            this.auditLogStore.setAuditLog(auditLog);
            if (logOnSuccess) {
                this.logStore.logSuccess("Audit log reloaded successfully.", "auditLog.reloadedOk");
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    // PRIVATE - in error case, log and reject promise
    async fetchAuditLog(userId, timestampFrom, timestampTo) {
        // TODO: make sure userId is sanitized
        const res = await makeAuthGetRequest(Endpoints.auditLog, { userId, timestampFrom, timestampTo });
        if (res.response) {
            return res.response.log;
        }
        else {
            // error path
            this.logStore.logResponseError(res, this.fetchAuditLog.name);
            return Promise.reject("Fetch audit log failed. For more see Error Logs.");
        }
    }
    dateToTimestamp(date) {
        return date.getTime().toString();
    }
}
